// @flow

import { get, values } from 'lodash';
import type { Flow, FlowNode, State } from './types';

const ZT_API_NAMESPACE = 'is_template';
const REDUX_STATE_PREFIX = 'flow';

export const selectFlows = (state: State) =>
  get(state, [REDUX_STATE_PREFIX, 'flows']);

export const selectFlow = (id: string | number, state: State): Flow => {
  return (selectFlows(state) || {})[id];
};

export const selectNode = (
  state: State,
  props: { flowId: string, nodeId: string }
): FlowNode => {
  return get(selectFlow(props.flowId, state), ['nodes', props.nodeId]);
};

export const selectNodeWithPlanLimits = (state: State, flowId: string) => {
  const flow = selectFlow(flowId, state);
  return values(flow.nodes).find(node => Boolean(node.plan_limits));
};

export const selectNodePlanValidation = (
  state: State,
  props: { flowId: string, nodeId: string }
) => {
  return get(selectNode(state, props), 'plan_limits');
};

export const selectIsFlowTemplate = (
  state: State,
  props: { flowId: string, nodeId: string }
): boolean => {
  const _props = { flowId: props.flowId, nodeId: props.nodeId || props.flowId };
  return get(selectNode(state, _props), [ZT_API_NAMESPACE], false);
};
